import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { ENV_CONFIG } from '../injection-tokens/environment.token';
import { EnvironmentConfig } from '../model/environment.model';

export abstract class BaseService<_T> {
    environment: EnvironmentConfig = inject(ENV_CONFIG);
    protected httpClient: HttpClient;
    protected serviceBaseUrl: string;

    protected constructor(
        protected injector: Injector,
        serviceBaseUrl: string
    ) {
        this.httpClient = injector.get(HttpClient);
        this.serviceBaseUrl = serviceBaseUrl;
    }

    protected getHttpParams(): HttpParams {
        return new HttpParams();
    }
}
